export enum EventName {
	RecognitionClick = 'Monarch Search Recognition Click',
	UserClick = 'Monarch Search User Click',
}
